import type { shell } from '@mysterra/copy/shell'

import { api } from '@/lib/api/client'

export type CopyShellEnvelope = {
  version: string
  shell: typeof shell
}

export async function fetchCopyShell(): Promise<CopyShellEnvelope> {
  const res = await api.v1.copy.shell.$get()
  if (!res.ok) {
    throw new Error(`copy/shell failed: ${res.status}`)
  }
  return (await res.json()) as CopyShellEnvelope
}
